import "Spatial/Data/Objects";

/** @namespace Spatial.Data */
NS("Accounting.Data");

/**
 * Spatial.Data.Objects source
 * @class
 * @extends Spatial.Data.Objects
 */
Accounting.Data.SpatialObjects = Class(Spatial.Data.Objects, {
    url: "Accounting/Web/SpatialObjects/",

    findForMap(options, callback)
    {
        return this.call("findForMap", options, callback);
    },

    getLegend(options, callback)
    {
        return this.call("getLegend", options, callback);
    },

});
